import useModalClass from 'hooks/useModalClass';
import useRecaptcha from 'hooks/useRecaptcha';
import Button from 'components/ui/Button/Button';
import { faCamera, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { showError, showSuccess } from 'utils/utils';
import ReactDOM from 'react-dom';
import LoadingBlock from './LoadingBlock';
// @ts-ignore
import domtoimage from 'dom-to-image-more';
import { sanitizeString } from 'utils/shared/utils';
import useDraggableModal from 'hooks/useDraggableModal';

const ScreenshotSupport: FC = () => {
  const { t } = useTranslation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const classList = useModalClass(showConfirmModal);
  const [loading, setLoading] = useState(false);
  const { handleRecapcha } = useRecaptcha();
  const [message, setMessage] = useState('');
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);

  useEffect(() => {
    if (showConfirmModal) {
      setMessage('');
    }
  }, [showConfirmModal]);

  const onClickSubmit = async () => {
    setLoading(true);

    const rootElement = document.getElementById('root');

    setTimeout(async () => {
      if (rootElement) {
        try {
          let ScreenshotBase64;
          try {
            ScreenshotBase64 = await domtoimage.toJpeg(rootElement, {
              quality: 0.95,
              cacheBust: true,
              filter: (el: any) =>
                el.tagName !== 'IMG' && !el.classList?.contains('modal-screenshot'),
              skipFonts: true,
            });
          } catch (err) {
            ScreenshotBase64 = 'cant complete screen';
          }

          const recaptchaToken = await handleRecapcha();

          const res = await axios.post('Utils/SendSupportMesage', {
            recaptchaToken,
            ScreenshotBase64,
            freeText: message,
          });

          if (res.data.hasErrors) {
            showError(res.data.errorMessage);
          } else {
            showSuccess(t('mo.send_support_message_success'));
          }
        } catch (error) {
          showError(t('something_went_wrong'));
          console.error(error);
        } finally {
          setShowConfirmModal(false);
          setLoading(false);
        }
      }
    }, 500);
  };

  const modalContent = (
    <div
      className="modal-overlay modal-overlay-top modal-screenshot"
      onClick={(e) => e.target === e.currentTarget && setShowConfirmModal(false)}
    >
      <div ref={modalRef} className={classList} style={modalStyle}>
        <div
          className={'modal-title  draggable-modal-handle' + (isDragging ? ' dragging' : '')}
          {...dragHandleProps}
        >
          <div>
            <span className="title mr-10"> {t('mo.send_support_message')}</span>
          </div>
          <div data-no-drag="true">
            <FontAwesomeIcon icon={faTimes} onClick={() => setShowConfirmModal(false)} />
          </div>
        </div>
        <div className="modal-content pt-10">
          <div className="text-md text-bold">{t('mo.are_you_sure')}</div>
          <div className="text-sm mt-20 mb-5">{t('notes')}</div>
          <textarea
            className="form-control text-sm"
            onChange={(e) => setMessage(sanitizeString(e.target.value))}
            style={{ height: '150px', resize: 'none' }}
            value={message}
          />

          {loading && <LoadingBlock />}
        </div>

        <div className="modal-footer">
          <Button
            className="btn btn-primary mr-a ml-0"
            title={t('confirm')}
            disabled={loading}
            onClick={() => onClickSubmit()}
          />
          <Button
            className="btn btn-default"
            title={t('close')}
            onClick={() => setShowConfirmModal(false)}
          />
        </div>
      </div>
    </div>
  );

  return (
    <Fragment>
      <FontAwesomeIcon
        className="s-history-icon"
        icon={faCamera}
        onClick={() => setShowConfirmModal(true)}
      />
      {showConfirmModal && ReactDOM.createPortal(modalContent, document.body)}
    </Fragment>
  );
};

export default ScreenshotSupport;
